export default __webpack_public_path__ + "static/media/IUSDP.328d55b4.png";